import { Link } from 'react-router'

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md py-16 text-center">
      <p className="font-mono text-xs tracking-widest text-muted uppercase">404</p>
      <h1 className="mt-2 text-lg font-semibold text-ink">Такой страницы нет</h1>
      <p className="mt-1 text-sm text-muted">
        Возможно, раздел ещё не сделан — LeadPilot собирается по этапам.
      </p>
      <Link to="/" className="mt-4 inline-block text-sm text-accent underline">
        Вернуться к состоянию
      </Link>
    </div>
  )
}
